"use client"

import { motion } from "framer-motion"
import {
    SiAngular,
    SiDotnet,
    SiJavascript,
    SiNextdotjs,
    SiNodedotjs,
    SiReact,
    SiTypescript,
    SiVuedotjs,
} from "react-icons/si"

const frameworkLogos = [
    {
        title: "Angular",
        href: "https://angular.io",
        node: <SiAngular aria-hidden="true" />,
    },
    {
        title: "Next.js",
        href: "https://nextjs.org",
        node: <SiNextdotjs aria-hidden="true" />,
    },
    {
        title: "React",
        href: "https://react.dev",
        node: <SiReact aria-hidden="true" />,
    },
    {
        title: "Vue.js",
        href: "https://vuejs.org",
        node: <SiVuedotjs aria-hidden="true" />,
    },
    {
        title: "TypeScript",
        href: "https://www.typescriptlang.org",
        node: <SiTypescript aria-hidden="true" />,
    },
    {
        title: "JavaScript",
        href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
        node: <SiJavascript aria-hidden="true" />,
    },

    {
        title: "Node.js",
        href: "https://nodejs.org",
        node: <SiNodedotjs aria-hidden="true" />,
    },
    {
        title: ".NET",
        href: "https://dotnet.microsoft.com",
        node: <SiDotnet aria-hidden="true" />,
    },
]

export default function FrameworksSectionMinimal() {
    return (
        <section className="container mx-auto px-4 py-20">
            <div className="border-border/70 border-t pt-12 dark:border-border/40">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    {/* Section Header */}
                    <div className="lg:col-span-3">
                        <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                            Stack
                        </span>
                    </div>

                    {/* Content */}
                    <div className="flex flex-col gap-12 lg:col-span-9">
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                            className="max-w-3xl font-light text-muted-foreground text-xl leading-relaxed md:text-3xl"
                        >
                            The{" "}
                            <span className="font-normal text-foreground">
                                stack
                            </span>{" "}
                            I reach for, day to day.
                        </motion.p>

                        <div className="grid grid-cols-2 gap-px bg-border/70 sm:grid-cols-4 dark:bg-border/40">
                            {frameworkLogos.map((framework, index) => (
                                <motion.a
                                    key={framework.title}
                                    href={framework.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{
                                        delay: index * 0.05,
                                        duration: 0.5,
                                    }}
                                    viewport={{ once: true }}
                                    className="group relative flex aspect-square flex-col items-center justify-center gap-4 bg-background p-6 transition-colors hover:bg-muted/50"
                                >
                                    <div className="text-4xl text-muted-foreground transition-colors duration-300 group-hover:text-foreground">
                                        {framework.node}
                                    </div>
                                    <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest transition-colors group-hover:text-foreground">
                                        {framework.title}
                                    </span>
                                </motion.a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
